import { type RouteObject } from 'react-router'
import Home from './pages/Home'

const homeRoutes: RouteObject[] = [
  {
    index: true,
    path: '/',
    element: <Home />
  },
  {
    index: true,
    path: 'home',
    element: <Home />
  }
]

export default homeRoutes
